import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const APPLICATIONS_UPSELL_MODAL = 'applications_upsell_modal';

// https://dataportal.zillowgroup.net/event-registry/3381
export const emitApplicationsUpsellModalViewEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3381',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'applications_upsell_modal',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3382
export const emitApplicationsUpsellEnableApplicationsClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3382',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'button_to_enable_applications',
      trigger_object_nm: APPLICATIONS_UPSELL_MODAL,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.EnableApplications,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
